/*
  FAQ accordion.

  The height is animated in CSS through grid-template-rows going from 0fr to
  1fr, so this script only sets aria-expanded and lets the stylesheet do the
  moving. Measuring heights here and setting them in pixels would break the
  moment an answer reflowed at a different width.
*/
if (!customElements.get('faq-page')) {
  class FaqPage extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const toggle = event.target.closest('[data-faq-toggle]');
      if (!toggle) return;

      const open = toggle.getAttribute('aria-expanded') === 'true';

      /*
        Reading the setting from the DOM rather than being told it, so the
        theme editor can change it without this script being reloaded.
      */
      if (!open && this.hasAttribute('data-one-at-a-time')) {
        this.querySelectorAll('[data-faq-toggle][aria-expanded="true"]').forEach((other) => {
          if (other !== toggle) other.setAttribute('aria-expanded', 'false');
        });
      }

      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    }
  }

  customElements.define('faq-page', FaqPage);
}
